import { buttonProps } from './button.mjs';

const buttonGroupProps = {
  size: buttonProps.size,
  type: buttonProps.type
};

export { buttonGroupProps };
//# sourceMappingURL=button-group.mjs.map
